"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDateRange = addDateRange;
exports.downFile = downFile;
exports.download = download;
exports.getDate = getDate;
exports.handleTree = handleTree;
exports.parseTime = parseTime;
exports.praseStrEmpty = praseStrEmpty;
exports.resetForm = resetForm;
exports.selectDictLabel = selectDictLabel;
exports.sprintf = sprintf;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.json.parse.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.constructor.js");
require("core-js/modules/es.regexp.dot-all.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.sticky.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.url.js");
require("core-js/modules/web.url.to-json.js");
require("core-js/modules/web.url-search-params.js");
require("core-js/modules/web.url-search-params.delete.js");
require("core-js/modules/web.url-search-params.has.js");
require("core-js/modules/web.url-search-params.size.js");
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _cloud = require("@/utils/cloud");
/**
 * 通用js方法封装处理
 * Copyright (c) 2019 ruoyi
 */

var baseURL = process.env.VUE_APP_BASE_API;

// 日期格式化
function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  var format = pattern || '{y}-{m}-{d} {h}:{i}:{s}';
  var date;
  if ((0, _typeof2.default)(time) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time, 10);
    } else if (typeof time === 'string') {
      // eslint-disable-next-line prefer-regex-literals
      time = time.replace(new RegExp(/-/gm), '/');
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  // eslint-disable-next-line camelcase
  var timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value;
    }
    return value || 0;
  });
  return timeStr;
}

// 表单重置
function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].clearValidate();
  }
}

// 添加日期范围
function addDateRange(params, dateRange) {
  var search = params;
  search.beginTime = '';
  search.endTime = '';
  if (dateRange) {
    search.beginTime = this.dateRange[0];
    search.endTime = this.dateRange[1];
  }
  return search;
}

// 回显数据字典
function selectDictLabel(datas, value) {
  var actions = [];
  Object.keys(datas).map(function (key) {
    if (datas[key].dictValue === '' + value) {
      actions.push(datas[key].dictLabel);
      return false;
    }
    return true;
  });
  return actions.join('');
}

// 通用下载方法
function download(fileName, context) {
  var ctx = context || _cloud.urls.user;
  var downloadUrl = baseURL + ctx + '/common/download?' + 'fileName=' + encodeURI(fileName) + '&delete=' + true;
  window.location.href = downloadUrl;
}

// 通用下载文件方法  后台为附件形式
function downFile(res) {
  var downloadFile = document.createElement('a');
  var blob = new Blob([res.data], {
    type: 'application/vnd.ms-excel;charset=UTF-8'
  });
  downloadFile.href = window.URL.createObjectURL(blob);
  downloadFile.download = decodeURI(res.request.getResponseHeader('Content-disposition').split('filename=')[1]);
  downloadFile.click();
  window.URL.revokeObjectURL(downloadFile.href);
}

// 字符串格式化(%s )
function sprintf(str) {
  var args = arguments;
  var flag = true;
  var i = 1;
  str = str.replace(/%s/g, function () {
    var arg = args[i++];
    if (typeof arg === 'undefined') {
      flag = false;
      return '';
    }
    return arg;
  });
  return flag ? str : '';
}

// 转换字符串，undefined,null等转化为""
function praseStrEmpty(str) {
  str !== null && str !== void 0 ? str : str = '';
  return str;
}

/** 构造树型结构数据
 * @param { * } data 数据源
 * @param { * } id id字段 默认 'id'
 * @param { * } parentId 父节点字段 默认 'parentId'
 * @param { * } children 孩子节点字段 默认 'children'
 * @param { * } rootId 根Id 默认 0
 * @return { Array } 处理完成的数据对象
 */
function handleTree(data, id, parentId, children, rootId) {
  id = id || 'id';
  parentId = parentId || 'parentId';
  children = children || 'children';
  rootId = rootId || 0;

  // 对源数据深度克隆
  var cloneData = JSON.parse(JSON.stringify(data));
  // console.log(cloneData);
  // 循环所有项
  var treeData = cloneData.filter(function (father) {
    var branchArr = cloneData.filter(function (child) {
      // 返回每一项的子级数组
      return father[id] === child[parentId];
    });
    if (branchArr.length > 0) father.children = branchArr;
    // 返回第一层
    return father[parentId] === rootId || Number(father[parentId]) === Number(rootId);
  });

  /*  const a = (item, p/!* p -> parent *!/) => {
      if (item.path) {
        if (!p?.path || (item.path && item.path[0] === '/')) item.path = `${window.location.host}${item.path[0] === '/' ? '' : '/'}${item.path}`
        else if (p) item.path = `${p.path}/${item.path}`
        Array.isArray(item?.children) && item.children.forEach(c/!* c -> children *!/ => a(c, item))
      }
    }
    treeData.forEach(a)*/

  return treeData.length > 0 ? treeData : data;
}

/* 获取默认时间
 * yyyy-MM-dd HH:mm:ss */
function getDate() {
  var now = new Date();
  var year = now.getFullYear();
  var month = now.getMonth();
  var date = now.getDate();
  var hour = now.getHours();
  var minutes = now.getMinutes();
  var second = now.getSeconds();
  month = month + 1;
  var defaultDate = "".concat(year, "-").concat(month, "-").concat(date, " ").concat(hour, ":").concat(minutes, ":").concat(second);
  return defaultDate;
}